import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import LandingPage from "./pages/LandingPage";
import Login from "./pages/Login";
import Register from "./pages/Register";

// ❗ REMOVE ChatPage from Adam/Eve routing
import ChatPage from "./pages/ChatPage";  

// NEW AI CHAT PAGE
import AiChatPage from "./pages/AiChatPage";

import "./App.css";

function App() {
  return (
    <div className="app">
      <Router>
        <Routes>
          {/* MAIN PAGES */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* OLD CHAT (for human-to-human ONLY) → keep it */}
          <Route path="/chat" element={<ChatPage />} />

          {/* NEW AI CHAT ROUTE FOR ADAM & EVE */}
          <Route path="/chatai/:persona" element={<AiChatPage />} />
            {/* <Route path="/chat/:partner" element={<ChatPage />} /> */}
            <Route path="/chat/:partner" element={<AiChatPage />} />

        </Routes>
      </Router>
    </div>
  );
}

export default App;
